import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import { useStore } from "vuex"
interface Props {
    my?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'borderHorizontal',
  props: {
    my: { default: "my-3" }
  },
  setup(__props: any) {


const store = useStore();

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[props.my], "border-1 border-gray border-bottom"])
  }, null, 2))
}
}

})